module.exports = __webpack_public_path__ + "img/BANNER_MODULOS_INTERNO.5d7011a7.png";